import { ArrowLeft, ArrowRight } from 'lucide-react';
import './ServiceDetail.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const KnowledgeTranslation = () => {
   <ScrollToTop />
  return (
    <>
      <section className="service-hero">
        <div className="container">
          <a href="/services" className="back-link">
            <ArrowLeft size={24} /> Back to All Services
          </a>
          <h1>Knowledge Translation, Learning & Influence</h1>
          <p className="lead">
            We ensure evidence is accessible, usable, and influential by transforming data into compelling knowledge products and learning processes that drive change.
          </p>
        </div>
      </section>

      <section className="section service-detail">
        <div className="container">
          <h2>Our Key Services</h2>
          <ul className="service-list">
            <li>
              <strong>Policy briefs, learning reports, and infographics</strong>
              <p>Concise, visually engaging summaries that communicate complex findings clearly and persuasively.</p>
            </li>
            <li>
              <strong>Data storytelling and visual analytics</strong>
              <p>Compelling narratives and interactive visuals that make evidence memorable and actionable.</p>
            </li>
            <li>
              <strong>Stakeholder learning forums and convenings</strong>
              <p>Facilitated events that foster knowledge exchange, collaboration, and collective learning.</p>
            </li>
            <li>
              <strong>Knowledge management systems</strong>
              <p>Platforms to capture, organise, store, and share organisational learning effectively.</p>
            </li>
            <li>
              <strong>Advocacy and evidence-to-policy pathways</strong>
              <p>Strategic approaches to influence decision-makers with robust, credible evidence.</p>
            </li>
          </ul>

          <div className="cta-section">
            <h3>Ready to Turn Evidence into Lasting Change?</h3>
            <div className="btn-group">
              <a href="/contact" className="btn btn-primary">
                Amplify Your Evidence Today <ArrowRight size={24} />
              </a>
              <a href="/services" className="btn btn-secondary">
                Explore All Services <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        {/* Paste the full footer here */}
      </footer>
    </>
  );
};

export default KnowledgeTranslation;